<div class="field-name mt-4">
  Gambling Countries
</div>

<div class="list_container me-2">
  <div class="mt-4 ms-3 me-3 mb-4">
    <div class="search-actions mb-3">
      <mat-form-field class="no-padding list-search" appearance="outline">
        <input matInput class="placeholders search-input-shadow" [(ngModel)]="gamblingCountrySearch" (keyup)="searchGamblingCountries()" placeholder="Search Countries" />
        <mat-icon matSuffix class="material-icons search_icon">search</mat-icon>
      </mat-form-field>
    </div>

    <div class="deals_container mt-3">
      <div class="deals_sub_container">
        <table mat-table [dataSource]="gamblingCountriesDataSource" matSort #sort="matSort">
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <span class="material-icons include-icon-selected" (click)="selectGamblingCountry(row)">
                check
              </span>
            </td>
          </ng-container>

          <ng-container [matColumnDef]="config.displayField">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
              Country
            </th>
            <td mat-cell *matCellDef="let row">
              <span class="table_value_name">{{ row[config.displayField] }}</span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="config.displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: config.displayedColumns"></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="3">
              No data matching the filter
            </td>
          </tr>
        </table>

        <mat-paginator #gamblingPaginator [pageSize]="10" [length]="pageLength" [pageSizeOptions]="[10,25,100]" (page)="handleCountryPage($event)">
        </mat-paginator>
      </div>

      <mat-divider [vertical]="true"></mat-divider>

      <div class="deals_sub_container">
        <div class="flex_column fix-height">
          <mat-list>
            <mat-list-item>
              <div class="header-row">
                <div class="col-name table_header_name">
                  Country
                </div>

                <div class="col-action">
                  <span class="material-icons" style="cursor:pointer;color:gray" (click)="removeAllGamblingCountries()">
                    cancel
                  </span>
                </div>
              </div>
            </mat-list-item>
          </mat-list>

          <div class="selected-list-content">
            <div *ngIf="selectedGamblingCountries.length" class="list_container_content">
              <mat-list>
                <mat-list-item *ngFor="let country of selectedGamblingCountries; let last = last">
                  <div class="item-row">
                    <div class="col-name">
                      {{ country[config.displayField] }}
                    </div>

                    <div class="col-action">
                      <span class="material-icons" (click)="removeGamblingCountry(country)">
                        cancel
                      </span>
                    </div>
                  </div>

                  <mat-divider *ngIf="!last"></mat-divider>
                </mat-list-item>
              </mat-list>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>